<script lang="ts">
    import { tick } from "svelte"
    import { clickOutside } from "../../../../../helper"
    import { appliedPricegroups } from "../../../../../store"
    import { getAddress, getAddresses, getPriceCalculationById, getPriceCalculations } from "../../../../../api"
    import { mdiNotebookPlus } from "@mdi/js"
    import AddressForm from "../../../../widgets/AddressForm.svelte"
    import TextField from "./TextField.svelte"
    import SearchField from "../../../addresses/SearchField.svelte"
    import { emptyAddressObj } from "../../../../../helperObjects"
    import Modal from "../../../../widgets/Modal.svelte"
    import hash from "object-hash"
    import { applyPCalc } from "../../../../../functions/operations/pricegroup"
    import { updateOperationEndCustomerAddress } from "../../../../../../../api/hooks/config-client"
    import { _ } from "svelte-i18n"
    export let operation: OperationOut

    let addressFormElement: HTMLFormElement
    //@ts-ignore
    let formData: Address = emptyAddressObj
    let updateFormDataByAddress: (address: Address) => Promise<void>
    let resetForm: () => void
    let showForm: boolean = false
    let formSubmitAction: string
    let dontUpdate = false
    let hashForm = hash(formData)
    setTimeout(() => {
        hashForm = hash(formData)
    }, 100)
    let showSuccess = false
    let cleared = false

    const setFormDataByOperation = () => {
        if (resetForm) resetForm()

        if (operation.endCustomerFullAddress) {
            formData = JSON.parse(JSON.stringify(operation.endCustomerFullAddress))
        } else {
            formData.person.firstname = operation?.endCustomerAddress?.name2 ?? ""
            formData.person.lastname = operation?.endCustomerAddress?.name3 ?? ""

            formData.contact.email = operation?.endCustomerEmail ?? ""
            formData.contact.phone = operation?.endCustomerPhone ?? ""
            let streetParts = (operation?.endCustomerAddress?.street ?? "").split(" ")
            let houseNumber = streetParts.pop()
            formData.location.houseNumber = houseNumber ?? ""
            formData.location.city = operation?.endCustomerAddress?.city ?? ""
            formData.location.postcode = operation?.endCustomerAddress?.postcode ?? ""
            formData.location.street = streetParts.join(" ")

            formData.vat = operation?.endCustomerVAT ?? null
            formData.company.name = operation?.endCustomerAddress?.name1 ?? ""
        }
    }

    const submit = (e: CustomEvent<{ action: string; form: any }>) => {
        const action = e.detail.action
        const form = e.detail.form
        if (hash(form) == hashForm) {
            return
        }
        hashForm = hash(form)
        switch (action) {
            case "save":
                operation = updateOperationEndCustomerAddress(operation, form)
                showSuccess = true
                setTimeout(() => {
                    showSuccess = false
                }, 3000)

                showForm = false
                break

            case "update-cart":
                operation = updateOperationEndCustomerAddress(operation, form)
                showSuccess = true
                setTimeout(() => {
                    showSuccess = false
                }, 3000)
        }
    }

    let priceCalculation: PriceCalculation
    let askToApplyPCalc = false

    // Wird als Event-Handler (on:selected) und direkt aufgerufen; beide Male
    // trägt das Argument die Adresse unter `detail`.
    const onAddressSelected = async (e: { detail: Address }) => {
        formData = JSON.parse(JSON.stringify(e.detail))
        updateFormDataByAddress(formData)
        operation = updateOperationEndCustomerAddress(operation, formData)
        if (formData.type == "person" && formData.person?.parentCompany) {
            const resp = await getAddress(formData.person?.parentCompany)
            const parent = resp.data
            if (parent?.priceCalculation) {
                let pCalc
                if (parent.priceCalculation == "manual") {
                    pCalc = { data: JSON.parse(JSON.stringify(parent.priceCalculationManual)) }
                } else pCalc = await getPriceCalculationById(parent.priceCalculation, false)

                if (pCalc?.data) {
                    askToApplyPCalc = true
                    priceCalculation = pCalc.data
                }
            }
        } else if (formData?.priceCalculation) {
            let pCalc
            if (formData.priceCalculation == "manual") {
                let resp = await getAddress(formData?.id)
                if (resp.data) pCalc = { data: JSON.parse(JSON.stringify(resp?.data?.priceCalculationManual)) }
            } else pCalc = await getPriceCalculationById(formData.priceCalculation)
            if (pCalc?.data) {
                askToApplyPCalc = true
                priceCalculation = pCalc.data
            }
        } else {
            // find global pricegroup
            const {
                data: [pCalc],
            } = await getPriceCalculations({
                dealerNumber: operation.dealerNumber,
                groupName: null,
            })
            if (pCalc) {
                priceCalculation = pCalc
            } else {
                // default pricecalc
                priceCalculation = {
                    calculation: {
                        discountPercent: 0,
                        type: "surcharge",
                        surchargePercent: 0,
                        name: null,
                    },
                    exception: null,
                    groupName: null,
                    vat: 19, // TODO: get from dealer
                    dealerNumber: operation.dealerNumber,
                    expiryDates: [],
                    daysValid: 14,
                    globalCalculation: null,
                    ruleBasedCalculation: [],
                }
                priceCalculation.globalCalculation = priceCalculation.calculation
            }
            askToApplyPCalc = true
        }
    }

    const onClear = () => {
        operation.endCustomerFullAddress = null
        operation.endCustomerAddress = {
            name1: "",
            name2: "",
            name3: "",
            street: "",
            postcode: "",
            city: "",
            country: "",
            email: "",
            fax: "",
            phone: "",
            salutation: "",
        }

        // so dont refill by operation.endCustomerNumber
        cleared = true

        // WARNING: This will also refill address by operation.endCustomerNumber
        // setFormDataByOperation()
        if (resetForm) resetForm()
    }

    const operationUpdated = async () => {
        if (dontUpdate) {
            dontUpdate = false
            return
        }
        if (!cleared && !operation.endCustomerFullAddress && operation.endCustomerNumber) {
            let addresses = await getAddresses(
                {
                    dealerNumber: operation.dealerNumber,
                    customerNumber: operation.endCustomerNumber,
                },
                null,
                null,
                null,
                null,
                true
            )
            if (addresses.data.length > 0) {
                onAddressSelected({ detail: addresses.data[0] })
            }
        }
        await tick()
        setFormDataByOperation()
    }
    let innerWidth: number
    $: if (operation) {
        operationUpdated()
    }
    $: {
        let overlaycontent = document.getElementsByClassName("overlaycontent")[0]
        if (innerWidth <= 700) {
            if (showForm) overlaycontent.classList.add("overflow-hidden")
            else overlaycontent.classList.remove("overflow-hidden")
        } else {
            overlaycontent.classList.remove("overflow-hidden")
        }
    }
</script>

<svelte:window on:click="{() => (showForm = false)}" bind:innerWidth />

<div class="operation-address" class:open="{showForm}" use:clickOutside="{() => (showForm = false)}">
    <div class="operation-address-form">
        <TextField
            label="{$_('operationsOut.address.endCustomerAddress')}"
            value="{`${
                operation?.endCustomerAddress?.name1 && !operation?.endCustomerAddress?.name2
                    ? operation?.endCustomerAddress?.name1
                    : ''
            }  ${operation?.endCustomerAddress?.name2 ?? ''} ${
                operation?.endCustomerAddress?.name3 ? operation?.endCustomerAddress?.name3 + ',' : ''
            }
        ${operation?.endCustomerAddress?.street?.replace(/\s+/g, '') ? operation?.endCustomerAddress?.street + ',' : ''}
        ${operation?.endCustomerAddress?.postcode ?? ''} ${
            operation?.endCustomerAddress?.city ? operation?.endCustomerAddress?.city + ',' : ''
        }`}"
            readonly="{true}"
            showAsEditable="{true}"
            inputMdiIcon="{mdiNotebookPlus}"
            on:click="{() => (showForm = true)}"
        />
        <div class="mt-sm mr-sm ml-sm operationout-addressform" style="padding-bottom: 15px;">
            <SearchField
                headline="{$_('operationsOut.address.searchInAddressBook')}"
                on:selected="{onAddressSelected}"
                currentSelect="{formData.id}"
                on:clear="{onClear}"
            />
            <AddressForm
                bind:formData
                bind:formElement="{addressFormElement}"
                bind:submitAction="{formSubmitAction}"
                bind:updateFormDataByAddress
                bind:resetForm
                on:submit="{submit}"
                cartId="dummyId"
                showTelephoneNumber="{true}"
                showPaymentTerms="{true}"
                onlyBillingFields="{true}"
                noMandatoryMarkers="{true}"
            />
            <div>
                <div style="display: flex; justify-content: space-between;width: 100%;">
                    <div></div>
                    {#if showSuccess}
                        <div style="color: green; font-size: 0.7rem; display: flex; align-items: flex-end;">
                            {$_("operationsOut.address.saveData")}
                        </div>
                    {/if}
                </div>
            </div>
        </div>
    </div>
    <TextField
        label="{$_('operationsOut.address.endCustomerAddress')}"
        value="{`
        ${
            operation?.endCustomerAddress?.name1 && !operation?.endCustomerAddress?.name2
                ? operation?.endCustomerAddress?.name1
                : ''
        } ${operation?.endCustomerAddress?.name2 ?? ''} ${
            operation?.endCustomerAddress?.name3 ? operation?.endCustomerAddress?.name3 + ',' : ''
        }
        ${operation?.endCustomerAddress?.street?.replace(/\s+/g, '') ? operation?.endCustomerAddress?.street + ',' : ''}
        ${operation?.endCustomerAddress?.postcode ?? ''} ${operation?.endCustomerAddress?.city ?? ''}`}"
        readonly="{true}"
        showAsEditable="{true}"
        inputMdiIcon="{mdiNotebookPlus}"
        showIcon="{true}"
        on:click="{() => (showForm = true)}"
    />
</div>

{#if askToApplyPCalc}
    <Modal
        show="{askToApplyPCalc}"
        showCloseIcon="{false}"
        on:close="{() => {
            askToApplyPCalc = false
            priceCalculation = null
            showForm = true
        }}"
    >
        <div slot="header">{$_("operationsOut.address.applyPriceGroup")}</div>
        <div>
            {#if priceCalculation?.groupName === null}
                {$_("operationsOut.address.noPriceGroup")}<br />
                {$_("operationsOut.address.resetGlobal")}
            {:else}
                {formData.type == "person"
                    ? $_("operationsOut.address.partnerCompany")
                    : $_("operationsOut.address.selectedAddress")}
                {$_("operationsOut.address.priceGroupApplied", {
                    values: {
                        priceGroup: priceCalculation?.groupName || $_("components.operationDetails.manualPriceGroup"),
                        documentType:
                            operation.type == 1
                                ? $_("operationsOut.address.currentOffer")
                                : $_("operationsOut.address.currentOrderConfirmation"),
                    },
                })}
            {/if}
        </div>
        <div slot="footer">
            <button
                class="btn btn-secondary"
                on:click|stopPropagation|preventDefault="{() => {
                    askToApplyPCalc = false
                    priceCalculation = null
                    showForm = true
                }}"
            >
                {$_("operationsOut.address.no")}
            </button>
            <button
                class="btn"
                on:click|stopPropagation|preventDefault="{() => {
                    dontUpdate = true
                    let pCalcCopy = JSON.parse(JSON.stringify(priceCalculation))
                    applyPCalc(priceCalculation, operation, updateOperationEndCustomerAddress, formData).then((e) => {
                        // Mit übergebenem formData liefert applyPCalc das Paar
                        // [operation, formData] (pricegroup.ts:114-119).
                        if (Array.isArray(e)) {
                            operation = e[0]
                            formData = e[1]
                        } else {
                            operation = e
                        }
                        priceCalculation = null
                        askToApplyPCalc = false
                        setTimeout(() => {
                            $appliedPricegroups[operation?.id] = [
                                pCalcCopy
                                    ? pCalcCopy.groupName
                                        ? `${pCalcCopy?.groupName || $_('components.pcalcGroup.globalPriceGroup')} ${$_(
                                              'address.dealerNumberLabel'
                                          )}`
                                        : $_('components.operationDetails.manualPriceGroup')
                                    : '',
                                hash(operation),
                            ]
                        }, 100)
                    })
                }}"
            >
                {$_("operationsOut.address.yes")}
            </button>
        </div>
    </Modal>
{/if}
